module.exports = __webpack_public_path__ + "img/flechalinkhome.96a616ab.svg";